import * as React from "react"
import { Spinner as PhosphorSpinner } from "@phosphor-icons/react"
import { cn } from "../../utils"

export interface SpinnerProps extends React.ComponentProps<"div"> {
  /**
   * Size of the spinner
   * @default "md"
   */
  size?: "xs" | "sm" | "md" | "lg" | "xl"
}

const sizeMap = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
}

/**
 * Simple spinning loader icon using Phosphor Spinner
 *
 * @example
 * ```tsx
 * import { Spinner } from "@t-one-internal/design-system"
 *
 * // Basic usage
 * <Spinner />
 *
 * // Different sizes
 * <Spinner size="sm" />
 * <Spinner size="lg" />
 *
 * // Custom className
 * <Spinner className="text-red-500" />
 * ```
 */
function Spinner({ className, size = "md", ...props }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn("inline-flex", className)}
      {...props}
    >
      <PhosphorSpinner
        weight="bold"
        size={sizeMap[size]}
        className="animate-spin text-indigo-600"
      />
    </div>
  )
}

export { Spinner }
